<template>
  <section>
    <div
      class="tw:flex tw:flex-col tw:md:flex-row tw:w-full tw:lg:max-w-(--tw-breakpoint-landing) tw:md:max-w-[638px] tw:sm:max-w-[480px] tw:max-w-[300px] tw:md:py-4 tw:lg:px-0 tw:mx-auto tw:py-4"
    >
      <div class="tw:flex tw:flex-col tw:md:flex-row tw:w-full tw:gap-4 tw:items-center">
        <div class="tw:flex tw:justify-center tw:items-center tw:flex-shrink-0">
          <img
            src="../../assets/img/landing/landing_banner.gif"
            alt="Business Studio Banner"
            class="tw:w-[170px]"
            style="height: auto"
            loading="lazy"
          />
        </div>
        <p
          class="tw:text-center tw:md:text-left tw:text-base tw:lg:text-xl tw:mt-2 tw:md:mt-0"
          v-html="$t('tbs_mp_studio_description')"
        />
      </div>
    </div>
  </section>
</template>
